import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { RegisterComponent } from './register/register.component';
import { DiyModule } from './nridiy/diy.component.module';
import { HttpClientModule } from '@angular/common/http';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ToastrModule, ToastNoAnimationModule } from 'ngx-toastr';
// import { CountDownComponent } from './common/count-down/count-down.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { CountDownModule } from './common/count-down/count-down.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { ChatbotComponent } from './common/chatbot/chatbot.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    ChatbotComponent,
  ],
  imports: [
    AutocompleteLibModule,
    BrowserModule,
    DiyModule,
    FormsModule,
    HttpClientModule,
    NgxUiLoaderModule,
    ReactiveFormsModule,CountDownModule,
    ToastrModule.forRoot(),
    ToastNoAnimationModule.forRoot(),
    NgOtpInputModule,
    CarouselModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
